<template>
    <div class="mx-auto my-2">
    
        <div data-toggle="modal" data-target="#PolicyModal" @click="Agree()">
            <input type="radio" name="agreePolicy" value="true" v-model="agreePolicy"/>我同意隱私權政策
        </div>

        <div class="modal fade" id="PolicyModal" tabindex="-1" role="dialog" aria-labelledby="PolicyModalTitle" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="PolicyModalTitle">隱私權政策</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <textarea readonly style="border:none;width:100%;height:70vh">
杜威海外教育有限公司隱私保護及安全聲明

親愛的同學，您好：

依據中華民國個人資料保護法，杜威相關企業制定了隱私保護政策，請詳閱這份說明，以協助
您了解相關重要訊息。本隱私權保護政策，適用於您在杜威相關企業（包含杜威海外教育股份
有限公司、杜威遊留學、杜威外師、乂迪生科技股份有限公司）向您蒐集之個人資料（包含個
人姓名、公司名稱、職稱、地址、電話及電子郵件地址等得以直接或間接識別個人的相關資訊），
將僅限使用於本相關企業合於營業登記項目或章程所載及業務需要之客戶管理、行銷、客戶服
務及營業範圍內相關服務使用，期限自取得起始日至特定目的終止日為止，並遵守「個人資料
保護法」之規定妥善保護您的個人資訊。（杜威相關企業以下簡稱本相關企業）

於此前提下，您同意本相關企業得於法律許可之範圍內處理及利用相關資料以提供資訊或服務，
並得於本相關企業之營運地區向您提供優惠資訊，但您仍得依法律規定之相關個人資訊權利主
張如下事項：查詢、閱覽、複製、補充、更正、處理、利用及刪除。您亦可拒絕提供相關之個
人資料，惟可能無法及時享有本相關企業提供之相關活動與獲取各項資訊之權利。

請於本相關企業上班時間週一至週五，上午九點至晚上六點之間，以電話或電子郵件向本相關
企業聯繫。若來信請註明主旨「取消會員資料」。
連絡電話：04-2381-3698；
E-Mail：abroad＠dewey.com.tw

自我的保護措施
請妥善保管您的帳號、密碼及任何個人資料，不要將任何個人資料提供給任何人。若您是與他
人共享電腦或使用公共電腦，切記要關閉瀏覽器視窗，以防止他人讀取您的個人資料。

隱私權保護/安全聲明修訂
本相關企業將不定時修訂本隱私權保護/安全聲明內容，以符合最新之隱私權保護規範，而新的
內容將會呈現於此網頁。當我們在使用個人資料的規定上作出大幅度修改時，我們會在網頁上
張貼告示，以通知您相關事項。
                        </textarea>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" data-dismiss="modal">同意</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Nav from '@/components/Nav'
import {app} from '@/main'
import Vue from 'vue'
import axios from 'axios'
// import moment from 'moment'

export default {
    name: 'PrivacyPolicy',
    components:{
        Nav,
    },
    data () {
        return {
            agreePolicy:false,
        }
    },
    mounted(){
        
    },
    methods:{
        Agree(){
            this.agreePolicy = true;
            this.$emit('update:agree', this.agreePolicy)
        }
    },
}
</script>




// WEBPACK FOOTER //
// src/components/LineComponents/PrivacyPolicy.vue